import { Appointment } from 'kb-shared';
import { inFutureWithDelay } from 'kb-shared/utilities/momentHelpers';

// logic is changed in a way that appointment are regarded as future appointments for 1 hour after they are started
export const filterAppointmentsByStartTime = (
  appointments: Appointment[] | undefined,
  filterPastAppointment = false
): Appointment[] =>
  appointments?.filter((appointment: Appointment) => {
    if (!filterPastAppointment) {
      return inFutureWithDelay(appointment.startTime, 60);
    }

    return !inFutureWithDelay(appointment.startTime, 60);
  }) || [];

export const compareByStartTimeAscending = (first: Appointment, second: Appointment): number => {
  return new Date(first.startTime).getTime() - new Date(second.startTime).getTime();
};

export const compareByStartTimeDescending = (first: Appointment, second: Appointment): number => {
  return new Date(second.startTime).getTime() - new Date(first.startTime).getTime();
};
